import { render } from "./ProjectDetail.vue?vue&type=template&id=4e9e9b48&scoped=true"
import script from "./ProjectDetail.vue?vue&type=script&lang=js"
export * from "./ProjectDetail.vue?vue&type=script&lang=js"

import "./ProjectDetail.vue?vue&type=style&index=0&id=4e9e9b48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e9e9b48"

export default script